export const AGENT_ACTIVITY_TIMEOUT_MS = 15 * 60 * 1000;
export const AGENT_ACTIVITY_EVENT = "agent-api-activity";

export type AgentStatusValue = "ACTIVE" | "INACTIVE" | "ON_BREAK";

const BREAK_STATUSES = ["BREAK", "ON_BREAK", "PAUSED", "ON_PAUSE"];
let lastAgentActivityAt: number | undefined;

export function setLastAgentActivityAt(timestamp: number) {
  lastAgentActivityAt = timestamp;
}

export function getLastAgentActivityAt() {
  return lastAgentActivityAt;
}

export function clearLastAgentActivityAt() {
  lastAgentActivityAt = undefined;
}

export function markAgentActivity() {
  const timestamp = Date.now();
  setLastAgentActivityAt(timestamp);
  window.dispatchEvent(new CustomEvent<number>(AGENT_ACTIVITY_EVENT, { detail: timestamp }));
}

export function isBreakStatus(status?: string) {
  return !!status && BREAK_STATUSES.includes(status);
}

export function getDerivedAgentStatus(serverStatus?: string): AgentStatusValue {
  if (isBreakStatus(serverStatus)) {
    return "ON_BREAK";
  }

  const lastActivityAt = getLastAgentActivityAt();
  if (lastActivityAt && Date.now() - lastActivityAt >= AGENT_ACTIVITY_TIMEOUT_MS) {
    return "INACTIVE";
  }

  if (serverStatus === "INACTIVE") {
    return "INACTIVE";
  }

  return "ACTIVE";
}
